var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "35px",
    viewBox: "0 0 25 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pin icon Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quote-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quote---Loading-Copy",
    transform: "translate(-1229.000000, -210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin-icon",
    transform: "translate(1221.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "place"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 41 0 41 41 0 41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,3.41666667 C13.88875,3.41666667 8.54166667,8.76375 8.54166667,15.375 C8.54166667,24.34375 20.5,37.5833333 20.5,37.5833333 C20.5,37.5833333 32.4583333,24.34375 32.4583333,15.375 C32.4583333,8.76375 27.11125,3.41666667 20.5,3.41666667 Z M20.5,19.6458333 C18.1425,19.6458333 16.2291667,17.7325 16.2291667,15.375 C16.2291667,13.0175 18.1425,11.1041667 20.5,11.1041667 C22.8575,11.1041667 24.7708333,13.0175 24.7708333,15.375 C24.7708333,17.7325 22.8575,19.6458333 20.5,19.6458333 Z",
    id: "Shape",
    fill: "#333E48",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.4f23575feec8d38f42a038b26bdef212.svg";
export { ForwardRef as ReactComponent };